import React from 'react';
import { Link } from 'react-router-dom';
import { Flame, Facebook, Twitter, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <Flame className="w-8 h-8 text-amber-500" />
              <span className="text-xl font-bold">VikingFuneralPyres</span>
            </div>
            <p className="text-slate-400 mb-4">
              Celebrate life with fire, music, and glory. Leave the sadness behind and embrace a legendary sendoff worthy of sagas.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-slate-400 hover:text-amber-500 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-slate-400 hover:text-amber-500 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-slate-400 hover:text-amber-500 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-400 hover:text-amber-500 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-slate-400 hover:text-amber-500 transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-slate-400 hover:text-amber-500 transition-colors">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/create" className="text-slate-400 hover:text-amber-500 transition-colors">
                  Create Funeral
                </Link>
              </li>
              <li>
                <Link to="/my-funerals" className="text-slate-400 hover:text-amber-500 transition-colors">
                  My Funerals
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-2 text-slate-400">
              <li>Email: info@vikingfuneral.com</li>
              <li>Phone: (555) 123-4567</li>
              <li>Available 24/7</li>
            </ul>
          </div>
        </div>

        {/* Security Badges */}
        <div className="border-t border-slate-800 mt-8 pt-8">
          <div className="flex flex-wrap items-center justify-center gap-6 mb-6">
            <div className="flex items-center gap-2 bg-slate-800 px-4 py-2 rounded-lg border border-slate-700">
              <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              <span className="text-slate-300 text-sm font-medium">SSL Secured</span>
            </div>
            
            <div className="flex items-center gap-2 bg-slate-800 px-4 py-2 rounded-lg border border-slate-700">
              <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
              <span className="text-slate-300 text-sm font-medium">Data Protected</span>
            </div>
            
            <div className="flex items-center gap-2 bg-slate-800 px-4 py-2 rounded-lg border border-slate-700">
              <svg className="w-5 h-5 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="text-slate-300 text-sm font-medium">Verified Secure</span>
            </div>
            
            <div className="flex items-center gap-2 bg-slate-800 px-4 py-2 rounded-lg border border-slate-700">
              <svg className="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
              </svg>
              <span className="text-slate-300 text-sm font-medium">Secure Payments</span>
            </div>
          </div>
          
          <div className="text-center text-slate-400 text-sm">
            <p>&copy; {new Date().getFullYear()} VikingFuneralPyres.com. All rights reserved.</p>
            <p className="mt-2">Celebrate life. Honor legends. Embrace the fire.</p>
            <p className="mt-2 text-xs">Your data is encrypted and securely stored. We never share your personal information.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;